
import { useLanguage } from '@/contexts/LanguageContext';
import { translations, TranslationType } from '@/translations';

export const useTranslation = (): TranslationType => {
  const { language } = useLanguage();
  return translations[language];
};
